export const appMessage = {
  confirmCancelAssetCreation: {
    title: 'Cancel Create Asset',
    message: '<div>Are you sure you would like to cancel? This asset will not be created and changes will be lost</div>',
    okButtonText: 'YES',
    cancelButtonText: 'NO'
  },
  confirmCancelEditAssetCreation: {
    title: 'Cancel Edit Asset',
    message: '<div>Are you sure you would like to cancel? This asset will not be updated and changes will be lost</div>',
    okButtonText: 'YES',
    cancelButtonText: 'NO'
  },
  confirmTeamMemberDeletion: {
    title: 'Delete Team Member',
    message: '<div>Are you sure you would like to delete team member?</div>',
    okButtonText: 'YES',
    cancelButtonText: 'NO'
  },
  confirmPastEventSelection: {
    title: 'Confirm Past Event',
    message: '<div>Are you sure you want to save this asset to a past event?</div>',
    okButtonText: 'OK',
    cancelButtonText: 'Cancel'
  },
  confirmAssetTypeChange: {
    title: 'Confirm Asset Type change',
    message: '<div>Changing the Asset Type will only retain the inspection values that are the same. Do you want to proceed?</div>',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  confirmReserveTooHighThanShoot: {
    title: 'Check Reserve Price and Shoot Price',
    message: '<div>Reserve Price is greater than 120% of the shoot price.</div>',
    okButtonText: 'OK'
  },
  confirmReserveOptionForItemUnder5000: {
    title: 'Consider Buy Now option when Reserve Price under 5000',
    message: '<div>Consider listing asset in Buy Now format for reserve under 5000.</div>',
    okButtonText: 'OK'
  },
  confirmAcceptRemoveItem: {
    title: 'Accept Remove Item',
    message: '<div>Are you sure to remove this item?</div>',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  confirmAssetIncomplete: {
    title: '',
    message: '<div>This asset is now incomplete and will be available on the Work In Progress tab</div>',
    okButtonText: 'Ok',
    cancelButtonText: 'Cancel'
  },
  confirmCurrencyChange: {
    title: 'Confirm Currency Change',
    message: '<div>The location entered has caused the Currency of this asset-package to be updated. If any values have been entered on the assets these will NOT be converted and should be assessed. If a Contract has been generated, this may require it to be regenerated</div>',
    okButtonText: 'Continue',
    cancelButtonText: 'Cancel'
  },
  confirmInactiveLocation: {
    title: 'Inactive Location',
    message: '<div>This Location is inactive, please activate if want to use </div>',
    okButtonText: 'OK'
  },
  exportToExcelWarning: {
    title: '',
    message: '<div>WARNING – EXPORT OF CONFIDENTIAL DATA: The following document may contain confidential company information. ' +
      'Unless explicitly permitted to do so, <strong>do not</strong> distribute this document outside of the company if it contains shoot prices or equipment condition.</div>',
    okButtonText: 'OK'
  },
  yardDeliveryDateWarning: {
    title: 'RBA Live Message',
    message: '<div>Expected Yard delivery date should be 2 weeks prior to the sale day.</div>',
    okButtonText: 'OK'
  },
  confirmSaveChanges: {
    title: '',
    message: 'Are you sure you want to leave the Asset Summary page without saving?',
    okButtonText: 'OK',
    cancelButtonText: 'Cancel'
  },
  enableVSODefaultMessage: {
    title: 'Enabling VSO beyond Orlando',
    message: ' <strong>There are a couple of requirements that must be met in order to offer the VSO option to your consignor: </strong> ' +
    '    <ul> <li> The asset must have a value greater than $30,000 USD. </li>' +
    '    <li> The asset must be located outside of the auction event\'s sales region. </li> ' +
    '    <li> RSM approval is required before contracting with the customer. </li> ' +
    '    <li> Each asset is subject to a Full Inspection fee (click for fee chart <a href=\'https://mercury.ironplanet.com/asp/listing-fees.asp\' target="_blank">Web</a> / <a href=\'https://mercury.ironplanet.com/main/inspectserv/Listing-Fees-NA-printable.pdf\' target="_blank">PDF</a>). </li> ' +
    '    <li> If any of these requirements cannot be met but you would like to still offer VSO to the customer, special permission must be given. </li> </ul>' +
    '',
    width: '650px'
  },
  vsoTooltipMessage:{
    message: 'Click for VSO Information'
  }
};
